import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import useUserData from 'data-hooks/useUserData';
import { LOGOUT } from 'mocks/mutations';
import useLogoutClient from 'data-hooks/useUserData/useLogoutClient';
import IconHeart2 from 'components/icons/iconHeart2';
import IconBag from 'components/icons/IconBag';
import IconUserAccount from 'components/icons/iconUserAccount';
import IconMapMarker from 'components/icons/IconMapMarker';
import ToolbarIconButton from 'components/consumer/ToolbarIconButton';
import MobileAndTabletOnly from 'components/consumer/MobileAndTabletOnly';
import DesktopOnly from 'components/consumer/DesktopOnly';
import HeaderToolbarDropdown from './HeaderToolbarDropdownButton';
import NavbarShowroomLocator from './NavbarShowroomLocator';
const HeaderToolbarUI = t0 => {
  const $ = _c(29);
  const {
    bagCount,
    favoriteCount,
    accountTo,
    onBagClick: t1,
    onWishlistClick: t2
  } = t0;
  const onBagClick = t1 === undefined ? _temp : t1;
  const onWishlistClick = t2 === undefined ? _temp2 : t2;
  const {
    isLoggedIn,
    firstName,
    email
  } = useUserData();
  const [logout] = useMutation(LOGOUT);
  const logoutClient = useLogoutClient();
  let t3;
  if ($[0] !== logout || $[1] !== logoutClient) {
    t3 = async () => {
      await logout();
      logoutClient();
      window.location.replace("/");
    };
    $[0] = logout;
    $[1] = logoutClient;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const onLogoutClick = t3;
  let t4;
  if ($[3] !== accountTo) {
    t4 = <MobileAndTabletOnly><ToolbarIconButton data-xc="account" icon={IconUserAccount} to={accountTo} title="Account" className="lg:hidden" /></MobileAndTabletOnly>;
    $[3] = accountTo;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = isLoggedIn ? `Hi, ${firstName}` : "Log In";
  const t6 = isLoggedIn ? `${email}` : "";
  let t7;
  if ($[5] !== t5 || $[6] !== t6) {
    t7 = {
      text: t5,
      subtext: t6,
      link: "/customer/dashboard/"
    };
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t10;
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      text: "My Account",
      link: "/customer/dashboard/"
    };
    t9 = {
      text: "My Orders",
      link: "/customer/orders/"
    };
    t10 = {
      text: "Contact Us",
      link: "/contact-us/"
    };
    $[8] = t10;
    $[9] = t8;
    $[10] = t9;
  } else {
    t10 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t11;
  if ($[11] !== isLoggedIn || $[12] !== onLogoutClick) {
    t11 = isLoggedIn ? [{
      text: "Sign out",
      onClick: onLogoutClick
    }] : [];
    $[11] = isLoggedIn;
    $[12] = onLogoutClick;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11 || $[15] !== t7) {
    t12 = <DesktopOnly><HeaderToolbarDropdown data-xc="user-account" icon={IconUserAccount} title="User Account" dropdownItems={[t7, t8, t9, t10, ...t11]} /></DesktopOnly>;
    $[14] = t11;
    $[15] = t7;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <DesktopOnly><HeaderToolbarDropdown data-xc="showrooms" icon={IconMapMarker} title="Showrooms" iconClassName="[&_svg_path]:!stroke-[0.7]"><NavbarShowroomLocator /></HeaderToolbarDropdown></DesktopOnly>;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== favoriteCount || $[19] !== onWishlistClick) {
    t14 = <ToolbarIconButton badgeColor="red" count={favoriteCount} data-xc="wishlist" icon={IconHeart2} onClick={onWishlistClick} title="Wishlist" to="/wishlist/" prefetch={false} />;
    $[18] = favoriteCount;
    $[19] = onWishlistClick;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== bagCount || $[22] !== onBagClick) {
    t15 = <ToolbarIconButton badgeColor="brand" count={bagCount} data-xc="cart" icon={IconBag} onClick={onBagClick} title="Bag" />;
    $[21] = bagCount;
    $[22] = onBagClick;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t12 || $[25] !== t14 || $[26] !== t15 || $[27] !== t4) {
    t16 = <div className="flex relative right-[-10px] [&>*]:ml-[2px] [&>*:first-child]:ml-0">{t4}{t12}{t13}{t14}{t15}</div>;
    $[24] = t12;
    $[25] = t14;
    $[26] = t15;
    $[27] = t4;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  return t16;
};
HeaderToolbarUI.propTypes = {
  bagCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  favoriteCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  accountTo: PropTypes.string,
  onBagClick: PropTypes.func,
  onWishlistClick: PropTypes.func
};
export default HeaderToolbarUI;
function _temp() {}
function _temp2() {}